export const medicineTranslations = {
    en: {
        inventoryTitle: "Medicine Inventory",
        searchPlaceholder: "Search medicines...",
        addMedicineStock: "Add Medicine Stock",
        updateMedicineStock: "Update Medicine Stock",
        addMedicineDrawer: "Add Medicine",
        noStock: "No Stock",
        lowStock: "Low Stock",
        moderateStock: "Moderate Stock",
        inStock: "In Stock",
        medicineName: "Medicine Name",
        quantity: "Quantity",
        stockStatus: "Stock Status",
        addedBy: "Added By",
        addedOn: "Added On",
        addStockAction: "Add Stock",
        fetchError: "Failed to fetch medicines",
    },
    mr: {
        inventoryTitle: "औषध सूची",
        searchPlaceholder: "औषधे शोधा...",
        addMedicineStock: "औषध साठा जोडा",
        updateMedicineStock: "औषध साठा अद्यतनित करा",
        addMedicineDrawer: "औषध जोडा",
        noStock: "साठा नाही",
        lowStock: "कमी साठा",
        moderateStock: "मध्यम साठा",
        inStock: "पुरेशा साठा",
        medicineName: "औषधाचे नाव",
        quantity: "प्रमाण",
        stockStatus: "साठा स्थिती",
        addedBy: "द्वारे जोडले",
        addedOn: "जोडल्याची तारीख",
        addStockAction: "साठा जोडा",
        fetchError: "औषधे मिळवण्यात अयशस्वी",
    }
};